import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import fallbackImage from '../assets/images/IMG_0120.jpeg';

const AboutSection = () => {
  return (
    <Container className='about-section-wrapper'>
      <Row>
        <Col xs={12} md={6} className='d-flex flex-column justify-content-center'>
          <h1>AboutOur Work</h1>
          <p>ogogogogogogogogoogogogogoogogoogoogoogogoogooogooogooogggo</p>
          <a href='/'>Learn More</a>
        </Col>
        <Col xs={12} md={6} className='about-img-wrapper'>
          <img alt='hand' src={fallbackImage} />
        </Col>
      </Row>
    </Container>
  );
};

export default AboutSection;